// extracted by mini-css-extract-plugin
export default {"document":"RichEditComponent_document__P96aU"};